import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  chatBox: {
    height: 330,
    position: 'relative',
    width: '100%',
    ...dFlex(),

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      height: 260,
    },
  },
  chat: {
    width: '100%',
  },
  marketPrice: {
    ...dFlex(),
    flexDirection: 'column',
    gap: 4,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      marginBottom: 36,
      alignItems: 'flex-start',
      width: '100%',
    },
  },
  price: {
    color: theme.primary.p2,
  },
  chatHeader: {
    ...dFlex(),
    flexDirection: 'column',
  },
}));

export default useStyles;
